import React, { Component, Fragment } from 'react';
import Input from '../Input/index';
import  Dropdown  from 'Components/Dropdown';

//import styles from './styles.scss';
import { TAT_UNITS } from 'Constants/commonConstants';
import { formatToINR } from 'Utils/transform';
import ActionLoader from '../ActionLoader/index';
import Moment from 'moment';

export default class CommonChargesPopUp extends Component {

    constructor(props) {
        super(props);
    };

    render() {
        const {  transporterBidCCharges } = this.props;
        return (
            <div className="pa popup-container common-charges z-3">
                <div className="tLeft box-shadow bg-white br-5 pt-20 pl-20 pr-15 pb-15 z-1 ">
                    {
                        transporterBidCCharges.dataLoading && <ActionLoader/>
                    }
                    {
                        !transporterBidCCharges.dataLoading && <div className="flex flex-row mt-5">
                            <div className="flex-1 ">
                                <div className="tCenter fBold fs-14 mb-10">
                                    Common Charges
                                </div>
                                <div className="overflowAuto max-ht-300">
                                {
                                    (transporterBidCCharges.data || []).map((bidCC, index) => {
                                        return (
                                            <Fragment>
                                                {index === 0 && <div key={index} className="fs-14 fBold header-color mb-10 flex">
                                                    <div className="wt-100 mr-10">Description</div>
                                                    <div className="wt-70 mr-10">Movement Type</div>
                                                    <div className="wt-75 mr-10">Mode Type</div>
                                                    <div className="wt-25 mr-15">QBR</div>
                                                    <div className="wt-25 mr-10">Price</div>
                                                </div>}
                                                <div key={index} className="fs-14 section-sub-header-color semifBold mb-10 flex border-top-light pv-5">
                                                    <div className="wt-100 mr-10">{bidCC.description}</div>
                                                    <div className="wt-70 mr-10">{bidCC.movement_name}</div>
                                                    <div className="wt-70 mr-10">{bidCC.mode_name}</div>
                                                    <div className="wt-25 mr-15">{bidCC.other_charge_cost}</div>
                                                    <div className="wt-25 mr-10">{bidCC.price}</div>
                                                </div>
                                            </Fragment>

                                        )
                                    })
                                }
                                </div>
                            </div>
                        </div>
                    }
                    
                </div>
            </div>
        )
    }
}
